module.exports = __webpack_public_path__ + "static/img/weather32.e7041c5d.png";